module.exports = __webpack_public_path__ + "static/ARTS_IMAGE_4-c2dfc51c852831ec389ec75a3a80dc45.jpg";